/* eslint-disable */
'use strict'

import Component from 'gia/Component'
import store from 'store'
import icons from '../../images/icons.svg' // Parcel 2
import close from '../../images/close.svg' // Parcel 2
import remove from '../../images/remove.svg' // Parcel 2
import html2pdf from 'html2pdf.js'
import logo from '../../images/bet-logo.png'
import { getData } from './logoData'
import Bounce from 'bounce.js'
import ajaxforsvg from './ajaxforsvg'

export default class CompareSuppliers extends Component {
  constructor(element) {
    super(element)
    this.supplierWrapper = document.querySelector(
      '.c-incentive-listing__wrapper'
    )
    this.btnCompareContainer = document.querySelector('.compare-container')
    this.btnCompare = this.btnCompareContainer.querySelector('.btn-compare')
    this.btnClearAll = this.btnCompareContainer.querySelector('.btn-clear-all')
    this.btnSelectAll = this.btnCompareContainer.querySelector(
      '.btn-select-all'
    )
    this.compareWrapper = this.btnCompareContainer.querySelector(
      '.compare-wrapper'
    )
    this.tagList = this.btnCompareContainer.querySelector(
      '.compare-container__tag'
    )
    this.compareSpan = this.btnCompareContainer.querySelector(
      '.compare-wrapper span'
    )
    this.popContainer = document.querySelector('.compare-table-popup')
    this.tableBar = this.popContainer.querySelector('.compare-table-button')
    this.compareTable = this.popContainer.querySelector(
      '.compare-table-container'
    )
    this.closeBtn = this.popContainer.querySelector('.compare-table-close')
    this.btnPDF = this.popContainer.querySelector('.compare-table-pdf')
    this.backdrop = document.querySelector('.backdrop')
    this.url = futagoData.root_url
    this.bounce = new Bounce()
    this.bounce.scale({
      from: { x: 1, y: 1 },
      to: { x: 0.5, y: 2 },
      easing: 'sway',
      duration: 800,
      delay: 65,
      stiffness: 2,
    })

    ajaxforsvg([remove, icons, close])
  }

  checkbox() {
    const checkedEls = document.querySelectorAll('input.tile-checkbox:checked')
    this.renderSpinner()
    if (checkedEls.length === 0) {
      this.renderMessage('Please select suppliers to compare.')
      return
    }
    const supplierIds = Array.from(checkedEls).map(el => el.dataset.item)

    let id = null
    if (supplierIds.length > 1) {
      id = supplierIds.join('-')
    } else {
      id = supplierIds
    }
    fetch(this.url + '/wp-json/bet/v1/supplier?id=' + id)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.popup(data)
      })
  }

  getStore() {
    return store.get('compare-list')
  }

  showTag() {
    this.renderCompareList(this.getCompareList())
    this.renderCheckbox(this.getCompareList())
  }

  checkboxAll() {
    const compareEls = document.querySelectorAll('.m-compare')
    compareEls.forEach(e => this.changeCheckboxText(e, false))
    return compareEls
  }

  getCompareList() {
    let newCompareList = []
    let suppliers = []
    const compareList = this.getStore()
    let compareEls = document.querySelectorAll('.m-compare:checked')
    if (compareEls)
      suppliers = Array.from(compareEls).map(el => {
        return { id: el.dataset.item, name: el.dataset.title }
      })
    if (compareList && suppliers) {
      return [...compareList, ...suppliers]
    }
    if (!compareList && suppliers) return [...suppliers]

    return []
  }

  // <img src="${remove}" />

  renderCompareList(newCompareList) {
    if (newCompareList.length === 0) return
    store.set('compare-list', newCompareList)
    const tagEl = newCompareList
      .map(
        c =>
          `<li class="tag-item data-item-${c.id}" data-item='${c.id}'>
          <span class='text'>${c.name}</span>
          <a class="remove-tag" href='javascript:void(0);'>
          <svg>
	      <use xlink:href="#icon-remove"/>
          </svg>
        </svg>
        </a></li>`
      )
      .join('')
    this.tagList.innerHTML = ''
    this.tagList.insertAdjacentHTML('beforeend', tagEl)
  }

  renderCheckbox(newCompareList) {
    if (newCompareList.length === 0) return
    const compareEls = this.supplierWrapper.querySelectorAll('.m-compare')
    compareEls.forEach(e => {
      const itemId = e.dataset.item
      if (newCompareList.filter(c => c.id === itemId).length > 0) {
        this.changeCheckboxText(e, false)
      }
    })
  }

  getUniqueCompareList(newCompareList) {
    return (newCompareList = newCompareList.filter(
      (item, index) => index === newCompareList.findIndex(e => item.id === e.id)
    ))
  }

  selectAll() {
    this.checkboxAll()
    const newCompareList = this.getUniqueCompareList(this.getCompareList())
    this.renderCompareList(newCompareList)
    this.renderCheckbox(newCompareList)
  }

  clearAll() {
    store.remove('compare-list')
    this.tagList.innerHTML = ''
    const compareEls = document.querySelectorAll('.m-compare:checked')
    compareEls.forEach(e => {
      this.changeCheckboxText(e)
    })
  }

  removeTag(itemId) {
    const tagItem = this.btnCompareContainer.querySelector(
      `.tag-item.data-item-${itemId}`
    )
    const compareList = this.getStore()
    if (!compareList && compareList.length === 0) return
    const newCompareList = compareList.filter(item => item.id !== itemId)
    tagItem.remove()
    store.set('compare-list', newCompareList)
    // const compareEls = document.querySelectorAll('.m-compare:checked')
    // compareEls.forEach(e => {
    //   this.changeCheckboxText(e)
    // })
    const compareEl = document.querySelector(`#data-item-${itemId}`)
    this.changeCheckboxText(compareEl)
  }

  changeCheckboxText(tag, isChecked = true) {
    const compareBox = tag.closest('.compare-checkbox')
    const text = compareBox.querySelector('span')
    if (!isChecked) {
      text.textContent = 'Added'
      tag.checked = true
      tag.setAttribute('data-check', 1)
      return
    }
    if (isChecked) {
      text.textContent = 'Add to compare list'
      tag.checked = false
      tag.setAttribute('data-check', 0)
    }
  }

  renderCompareWrapper(toOpen = false) {
    if (toOpen) {
      this.btnCompareContainer.classList.remove('compare-container-close')
      return
    }
    if (
      this.btnCompareContainer.classList.contains('compare-container-close')
    ) {
      this.btnCompareContainer.classList.remove('compare-container-close')
    } else {
      this.btnCompareContainer.classList.add('compare-container-close')
    }
  }

  toggleCompareWrapper() {
    if (this.btnCompareContainer.classList.contains('hide')) {
      this.btnCompareContainer.classList.remove('hide')
    } else {
      this.btnCompareContainer.classList.add('hide')
    }
  }

  showCompareWrapper() {
    if (this.btnCompareContainer.classList.contains('hide'))
      this.btnCompareContainer.classList.remove('hide')
  }

  addToCompare(e) {
    if (e.target.closest('.m-incentive-tile__link')) return
    const compareContainer = e.target.closest('.compare-checkbox')
    if (!compareContainer) return
    const compare = compareContainer.querySelector('.m-compare')
    const isChecked = +compare.dataset.check
    const supplierTitle = compare.dataset.title
    const supplierId = compare.dataset.item
    const supplier = { id: supplierId, name: supplierTitle }
    if (isChecked) {
      this.changeCheckboxText(compare)
      this.removeTag(supplierId)
      this.bounce.applyTo(this.compareSpan)
      return
    }
    this.changeCheckboxText(compare, false)
    let compareList = []
    if (this.getStore()) compareList = this.getStore()

    if (
      compareList.length > 0 &&
      compareList.filter(c => c.id === supplier.id).length > 0
    )
      return

    compareList.push(supplier)
    store.set('compare-list', compareList)

    const newTag = `<li class="tag-item data-item-${supplierId}" data-item='${supplierId}'>
        <span class='text'>${supplierTitle}</span>
      <a class="remove-tag" href='javascript:void(0);'>
      <svg>
      <use xlink:href="#icon-remove"/>
        </svg>
        </a></li>`
    this.tagList.insertAdjacentHTML('beforeend', newTag)
    // this.renderCompareWrapper(true)
    this.showCompareWrapper()
    this.bounce.applyTo(this.compareSpan)
  }

  compareSuppliers() {
    const tagEls = this.tagList.querySelectorAll('li')
    this.popContainer.classList.remove('hide')
    this.backdrop.classList.remove('hide')
    this.renderSpinner()
    if (tagEls.length === 0) {
      this.renderMessage('Please select suppliers to compare.')
      return
    }
    const supplierIds = Array.from(tagEls).map(el => el.dataset.item)

    let id = null
    if (supplierIds.length > 1) {
      id = supplierIds.join('-')
    } else {
      id = supplierIds
    }
    fetch(this.url + '/wp-json/bet/v1/supplier?id=' + id)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.popup(data)
      })
  }

  creatList(terms, heading, key) {
    const term = terms[key]
    if (term.length === 0) {
      return `<li class="specs"><b>${heading}:</b><span class='number'>N/A</span></li>`
    }
    if (term.length > 0) {
      const termNew = term
        .map(e => (e.includes('+') ? Number.parseInt(e, 10) : e))
        .sort((a, b) => a - b)
      const min = Math.min(...termNew)
      const max = Math.max(...termNew)
      const number =
        min !== max
          ? `<span>${min}</span> - <span>${max}</span>`
          : `<span>${min}</span>`
      return `<li class="specs"><b>${heading}:</b><span class='number'>${number}</span></li>`
    }

    // const plus = term.filter(e => e.includes('+'))
    // return `<li class="specs"><b>${heading}:</b><span>${
    //   plus.length > 0
    //     ? ' < ' + Number.parseInt(plus[0], 10) + ' & ' + plus[0]
    //     : term.length > 0
    //     ? ' < ' +
    //       term.reduce((prev, curr) => (curr > prev ? curr : prev), term[0])
    //     : ''
    // } </span></li>`
  }

  popup(data) {
    const open = '<div class="compare-table">'
    const closure = '</div>'
    let conference = ''
    for (let i = 0; i < data.length; i++) {
      const supplier = data[i]
      const terms = supplier.taxonomy

      let newEl = `<ul class="compare-table-conference" data-item="${supplier.id}">`
      newEl += `<li class="image"><img src='${
        supplier.fields['banner_image']['sizes']['medium_large']
      }' /></li>`
      newEl += `<li class="title"><a href='${
        supplier.url
      }' target="_blank"><b>${supplier.title}</b></a><span>${
        supplier.fields.contact.address ? supplier.fields.contact.address : ''
      }</span></li>`
      newEl += `<div class='specs-container'><li class="specs"><b>Ground Area:</b><span class='number'>${
        supplier.fields['ground_area'] ? supplier.fields['ground_area'] : 'N/A'
      }</span></li>`
      newEl += `<li class="specs"><b>Booth Numbers:</b><span class='number'>${
        supplier.fields['booth_numbers']
          ? supplier.fields['booth_numbers']
          : 'N/A'
      }</span></li>`

      newEl += this.creatList(
        terms,
        'Theatre pax',
        'conference_meeting_theatre'
      )
      newEl += this.creatList(
        terms,
        'Offsite venue pax',
        'conference_offsite_venues'
      )
      newEl += this.creatList(
        terms,
        'Banquet pax',
        'conference_meeting_banquet'
      )
      newEl += this.creatList(
        terms,
        'Plenary pax',
        'conference_meeting_plenary'
      )
      newEl += this.creatList(
        terms,
        'Cocktail pax',
        'conference_meeting_cocktail'
      )
      newEl += `</div></ul>`
      conference += newEl
    }
    const result = open + conference + closure
    this.clear()
    this.showPopup()
    this.compareTable.insertAdjacentHTML('afterbegin', result)

    return result
  }

  hidePopup() {
    this.closeBtn.classList.add('hide')
    this.btnPDF.classList.add('hide')
    this.popContainer.classList.add('hide')
    this.backdrop.classList.add('hide')
    this.tableBar.classList.add('hide')
  }

  showPopup(isCompare = true) {
    this.closeBtn.classList.remove('hide')
    this.popContainer.classList.remove('hide')
    this.backdrop.classList.remove('hide')
    this.tableBar.classList.remove('hide')
    if (isCompare) this.btnPDF.classList.remove('hide')
  }

  renderSpinner() {
    this.backdrop.classList.remove('hide')
    this.popContainer.classList.remove('hide')
    const markup = `
      <div class="spinner">
        <svg>
          <use xlink:href="#icon-loader"></use>
        </svg>
      </div>
    `
    this.clear()
    this.compareTable.insertAdjacentHTML('afterbegin', markup)
  }

  renderMessage(message) {
    const markup = `
      <div class="message">
        <div class='message-icon'>
          <svg>
            <use href="#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
        <div class='message-close'> 
        <svg class="icon-close">
        <use xlink:href="#icon-close"></use>
       </svg>
       </div>
      </div>
    `
    this.clear()
    this.compareTable.insertAdjacentHTML('afterbegin', markup)
    document.querySelector('.message-close').addEventListener('click', e => {
      e.preventDefault()
      this.hidePopup()
    })
  }

  clear() {
    this.compareTable.innerHTML = ''
  }

  exportPDF() {
    // fetch('https://api.sejda.com/v2/html-pdf', {
    //   method: 'POST',
    //   body: JSON.stringify({ htmlCode: this.compareTable.innerHTML }),
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
    //   .then(response => {
    //     return response.json()
    //   })
    //   .then(data => {
    //     console.log(data)
    //   })

    const filename = 'ThisIsYourPDFFilename.pdf'
    const body = document.body.cloneNode(true)
    const table = document.querySelector('.compare-table')
    body.classList.add('pdf-body')
    const newEl = table.cloneNode(true)
    const title = document.createElement('div')
    const date = new Intl.DateTimeFormat('au').format(new Date())
    title.innerHTML = `<div class="table-header"><img class="table-image" src='${logo}'/><div class="table-text"><h2>Conference Capacity Overview</h2><h4>${date}</h4></div></div>`
    newEl.classList.add('tableStyle')
    // newEl.classList.remove('compare-table')
    newEl.style.position = 'static'
    // newEl.style.transform = 'scale(0.85)'
    body.innerHTML = ''
    body.appendChild(title)
    body.appendChild(newEl)
    const opt = {
      margin: 0,
      filename: 'BET_Conference_Capacity_Overview_' + date + '.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: {
        useCORS: true,
        allowTaint: false,
        scale: 2,
        // width: window.screen.availWidth,
        scrollX: -window.scrollX,
        scrollY: 0,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,
      },
      pagebreak: { after: '.table-header', avoid: 'ul' },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'p',
        // putOnlyUsedFonts: true,
      },
    }
    // html2pdf()
    //   .set(opt)
    //   .from(body)
    //   .save()
    html2pdf()
      .from(body)
      .set(opt)
      .toPdf()
      .get('pdf')
      .then(function(pdf) {
        var totalPages = pdf.internal.getNumberOfPages()
        //print current pdf width & height to console
        // console.log('getHeight:' + pdf.internal.pageSize.getHeight())
        // console.log('getWidth:' + pdf.internal.pageSize.getWidth())
        for (var i = 1; i <= totalPages; i++) {
          if (i === 1) continue
          pdf.setPage(i)
          pdf.setFontSize(10)
          pdf.setTextColor(150)
          //divided by 2 to go center
          pdf.text(
            i - 1 + ' of ' + (totalPages - 1),
            pdf.internal.pageSize.getWidth() / 2 - 2,
            pdf.internal.pageSize.getHeight() - 5
          )
          pdf.addImage(getData(), 'JPEG', 5, 5, 18, 9)
          pdf.text(
            `Conference Capacity Overview - ${date}`,
            pdf.internal.pageSize.getWidth() - 75,
            10
          )
          pdf.addImage(
            getData(),
            'JPEG',
            pdf.internal.pageSize.getWidth() - 23,
            pdf.internal.pageSize.getHeight() - 14,
            18,
            9
          )
        }
      })
      .save()
  }

  mount() {
    this.showCompareWrapper()
    this.showTag()
    this.supplierWrapper.addEventListener('click', e => this.addToCompare(e))
    this.tagList.addEventListener('click', e => {
      if (
        e.target.closest('.m-incentive-tile__link') ||
        e.target.closest('.tile-checkbox')
      )
        return
      e.preventDefault()
      const removeBtn = e.target.closest('.remove-tag')
      if (!removeBtn) return
      const itemId = removeBtn.closest('.tag-item').dataset.item
      this.removeTag(itemId)
    })
    this.btnClearAll.addEventListener('click', e => {
      e.preventDefault()
      this.clearAll()
    })
    this.btnSelectAll.addEventListener('click', e => {
      e.preventDefault()
      this.selectAll()
    })
    this.compareWrapper.addEventListener('click', e => {
      e.preventDefault()
      this.renderCompareWrapper()
    })
    this.btnCompare.addEventListener('click', e => {
      e.preventDefault()
      this.compareSuppliers()
      this.toggleCompareWrapper()
      this.renderCompareWrapper()
    })
    this.backdrop.addEventListener('click', () => {
      this.hidePopup()
    })
    this.closeBtn.addEventListener('click', e => {
      e.preventDefault()
      this.hidePopup()
      this.toggleCompareWrapper()
    })
    this.btnPDF.addEventListener('click', e => {
      e.preventDefault()
      this.exportPDF()
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/CompareSuppliers.js